// extracted by mini-css-extract-plugin
module.exports = {"NavbarLink":"navbarLinks-module--NavbarLink--Ga3Jl"};